import { BUTTON, COUNTER } from '@/src/constants/itinerary/addons'
import { MealInfo } from '@/src/types/itinerary'
import { isMealSelected } from '@/src/utils/itinerary/addons'
import { Box } from '@mui/material'
import AddonsItemCardWrapper from '../addonsItemCard'

const Meal = ({
    mealOptions,
    paxCount,
    selectedMealOptions,
    formatCurrency,
    handleAddMeal,
    handleRemoveMeal
}: {
    mealOptions: MealInfo[]
    paxCount: number
    selectedMealOptions: Partial<MealInfo>[]
    formatCurrency: (price: number) => string
    handleAddMeal: (meal: MealInfo) => void
    handleRemoveMeal: (meal: MealInfo) => void
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                // Mobile: flex container, Desktop: normal
                height: { xs: '100%', lg: 'auto' },
                display: { xs: 'flex', lg: 'block' },
                flexDirection: { xs: 'column', lg: 'initial' },
                minHeight: { xs: 0, lg: 'auto' }
            }}
        >
            {/* Scrollable Meals Grid Container */}
            <Box
                sx={{
                    // Mobile: fill flex space, Desktop: fixed maxHeight
                    flex: { xs: 1, lg: 'none' },
                    minHeight: { xs: 0, lg: 'auto' },
                    maxHeight: { xs: '100%', lg: '500px' },
                    overflowY: 'auto'
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: 'repeat(1, 1fr)',
                            lg: 'repeat(2, 1fr)'
                        },
                        gap: {
                            xs: 1,
                            lg: 2
                        },
                        p: 0.5
                    }}
                >
                    {mealOptions.map((meal, index) => {
                        const selectorType = paxCount > 1 ? COUNTER : BUTTON
                        const { code, mealType, description, price, mealImageUrl } = meal
                        const { isSelected, quantity } = isMealSelected(meal, selectedMealOptions)
                        const totalSelections = selectedMealOptions.length

                        return (
                            <AddonsItemCardWrapper
                                key={`${code}-${index}`}
                                imageUrl={mealImageUrl}
                                description={description}
                                price={formatCurrency(price)}
                                itemIndicator={{
                                    show: !!mealType,
                                    color: mealType === 'Veg' ? 'success.main' : 'error.main'
                                }}
                                onAddClick={() => handleAddMeal(meal)}
                                onRemoveClick={() => handleRemoveMeal(meal)}
                                selectorConfig={{
                                    type: selectorType,
                                    isSelected,
                                    quantity,
                                    totalSelections,
                                    minQuantity: 0,
                                    maxQuantity: paxCount
                                }}
                            />
                        )
                    })}
                </Box>
            </Box>
        </Box>
    )
}

export default Meal
